
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons';
import useTranslation from 'next-translate/useTranslation';
import { DEFAULT_LISTING_PAGE } from '@unreserved-frontend-v2/modules/listings/utils/routing/constants';
import { BoxSection } from '@unreserved-frontend-v2/ui/content-section/box-section/box-section';
import { SimplifiedBaseSectionProps } from '../layouts';
export const Step5Component = ({ stepNumber = '', subTitle = '' }: SimplifiedBaseSectionProps) => {
    const { t } = useTranslation('inner-pages');
    const config = {
        content: t('buying-simplified.step-5-content'),
        containerClassName: 'mt-11 lg:mt-[39px] md:mt-9 mb-11 md:mb-[70px]',
        buttonText: t('buying-simplified.step-5-button'),
        icon: faShieldCheck
    };
    return <BoxSection {...config} stepNumber={stepNumber} subTitle={subTitle} buttonHref={DEFAULT_LISTING_PAGE}/>;
};
export default Step5Component;

    async function __Next_Translate__getStaticProps__1955d79d567__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//learn-more/buying-simplified/step-5-component',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1955d79d567__ as getStaticProps }
  